export default (payloads, order) => {
  return payloads.find((payload, index) => index === order);
};
